import React, { useState } from "react";
import { Grid2 as Grid, Skeleton } from "@mui/material";
import HeaderWithFilter from "./HeaderWithFilter";
import {
  ButtonContainer,
  Card,
  NameSection,
  CardContentWrapper,
  PriceAndScore,
  Rating,
  TrendingNFTsSection,
} from "./styles";
import Loader from "../../components/shared-components/Loader";
import {
  ArrowForwardOrange,
  BlankImage,
  CheckOrange,
  LeafIcon,
} from "../../shared/icons";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { IconButtonSmall } from "../../components/ButtonsNew";
import { useNavigate } from "react-router-dom";
import { getValidImageUrl } from "../../utils";

interface TrendingNFTsRecord {
  id: string;
  image: string;
  nftType: string;
  nftName: string;
  price: number;
}

interface Props {
  isLoading: boolean;
  isLoadingMore: boolean;
  trendingNFTs: TrendingNFTsRecord[];
  currentPage: number;
  totalPages: number;
  getTrendingNFTsList: (
    name: string,
    blockchain_network: string,
    rank_by: string,
    category_id: string,
    eco_category_id: string,
    limit?: number,
    pageNo?: number,
    isLoadingMore?: boolean
  ) => void;
}

const TrendingNFTs: React.FC<Props> = ({
  isLoading,
  isLoadingMore,
  trendingNFTs,
  currentPage,
  totalPages,
  getTrendingNFTsList,
}) => {
  const { name, network, impactScore, categories, ecoCategories } = useSelector(
    (state: RootState) => state.DashboardFilter
  );
  const [imageLoaded, setImageLoaded] = useState(false);
  const navigate = useNavigate();

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const handleLoadMore = () => {
    if (currentPage < totalPages) {
      getTrendingNFTsList(
        name,
        network,
        impactScore,
        categories,
        ecoCategories,
        20,
        currentPage + 1,
        true
      );
    }
  };

  return (
    <TrendingNFTsSection>
      <HeaderWithFilter
        heading="Trending Digital Assets"
        getFilteredNFTs={getTrendingNFTsList}
      />
      <Grid container spacing={2}>
        {isLoading ? (
          <Loader />
        ) : trendingNFTs?.length > 0 ? (
          trendingNFTs?.map((nft: any) => {
            return (
              <Grid size={{ xs: 12, md: 2.4 }} key={nft?.id}>
                <Card onClick={() => navigate(`/nft-details/${nft?.id}`)}>
                  {!imageLoaded && (
                    <Skeleton
                      variant="rectangular"
                      width="100%"
                      height={200}
                      animation="wave"
                      sx={{
                        marginBottom: 2,
                      }}
                    />
                  )}
                  <img
                    src={getValidImageUrl(nft?.image, BlankImage)}
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.src = BlankImage;
                    }}
                    alt="nft_image"
                    style={{ display: imageLoaded ? "block" : "none" }}
                    onLoad={handleImageLoad}
                  />
                  <CardContentWrapper>
                  <div className="content-wrapper">
                  <NameSection>
                    <span>{nft?.nftType}</span>
                    <CheckOrange />
                  </NameSection>
                  <h5 title={nft?.nftName}>{nft?.nftName}</h5>
                  </div>
                  <PriceAndScore>
                    <h6
                      style={{
                        margin: 0,
                        fontSize: "16px",
                        fontWeight: 400,
                        color: "#091C00",
                      }}
                    >
                      {nft?.price}{" "}
                      {nft?.networkId === 1
                        ? "ETH"
                        : nft?.networkId === 137
                        ? "POL"
                        : "HBAR"}
                    </h6>
                    <Rating value={nft?.ecoScore}>
                      <LeafIcon />
                      <span>
                        {typeof nft?.ecoScore === "number"
                          ? nft.ecoScore.toFixed(1)
                          : "0"}
                      </span>
                    </Rating>
                  </PriceAndScore>
                  </CardContentWrapper>
                  {/* <BidButton>
                  Place Bid
                  <ArrowForward />
                </BidButton> */}
                </Card>
              </Grid>
            );
          })
        ) : (
          <div>No Results Found!</div>
        )}
      </Grid>
      {isLoadingMore && (
        <div style={{ marginTop: "20px" }}>
          <Loader />
        </div>
      )}

      {/* action button */}
      {!isLoadingMore && currentPage < totalPages && (
        <ButtonContainer>
          <IconButtonSmall
            icon={<ArrowForwardOrange />}
            onClick={handleLoadMore}
          >
            View More
          </IconButtonSmall>
        </ButtonContainer>
      )}
    </TrendingNFTsSection>
  );
};

export default TrendingNFTs;
